export default "__VITE_ASSET__8f47c296__"